import { Skeleton } from '@renderer/components/ui/skeleton'

// Ragged right edge, so it reads as prose rather than a progress bar.
const BAR_WIDTHS = ['w-full', 'w-[88%]', 'w-[62%]']

/**
 * Placeholder for a summary that hasn't started streaming yet — a first
 * paragraph's worth of lines at the summary's own line height, nothing more.
 *
 * Kept short deliberately. The designs show no body at all in this state, and
 * a full-length skeleton both overstates how much is coming and makes the swap
 * to the first tokens a bigger jump, not a smaller one.
 *
 * Shown only while preparing — a skeleton tail *under* growing text would
 * shift on every token.
 */
export function MeetingSummarySkeleton() {
  return (
    <div aria-hidden="true" className="flex flex-col gap-2">
      {BAR_WIDTHS.map((width) => (
        <Skeleton key={width} className={`h-3 ${width}`} />
      ))}
    </div>
  )
}
